import getFixerAppIcon from './getFixerAppIcon.js';

// A report targets a published app the fixer can observe, so hidden apps (including
// unpublished drafts) are not selectable.
const buildFixerAppOptions = (appsMetadata = []) =>
  (appsMetadata || [])
    .filter((app) => app?.type === 'action' && app?.hidden !== true)
    .map((app) => ({ label: app.name || app.id, value: app.id, icon: getFixerAppIcon(app) }))
    .sort((a, b) => a.label.localeCompare(b.label));

export default buildFixerAppOptions;
